import React, { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabaseClient';
import { useTheme } from '../../lib/useTheme';
import TaskItem from '../shared/TaskItem';

const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b', logoGrad:'linear-gradient(135deg, #534AB7, #1D9E75)' };
const font = "'DM Sans', sans-serif";

export default function SharedTaskList({ clientId, adminId, isAdmin, clientName }) {
  const t = useTheme();
  const [tasks, setTasks] = useState([]);
  const [title, setTitle] = useState('');
  const [dueDate, setDueDate] = useState('');
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    if (!clientId) return;
    supabase.from('shared_tasks').select('*').eq('client_id', clientId).order('created_at', { ascending: false }).then(({ data }) => {
      if (data) setTasks(data);
    });
  }, [clientId, refresh]);

  const r = () => setRefresh(n => n + 1);
  const inp = { width:'100%', padding:'8px 12px', border:`0.5px solid ${t.border}`, borderRadius:10, fontSize:13, fontFamily:font, background:t.card, color:t.text, outline:'none', boxSizing:'border-box' };

  const addTask = async () => {
    if (!title.trim()) return;
    await supabase.from('shared_tasks').insert({
      client_id: clientId, admin_id: adminId, title: title.trim(),
      assigned_by: isAdmin ? 'T&D' : 'client', due_date: dueDate || null,
    });
    setTitle(''); setDueDate(''); r();
  };

  const toggleTask = async (task) => {
    const newStatus = task.status === 'completed' ? 'pending' : 'completed';
    await supabase.from('shared_tasks').update({
      status: newStatus,
      completed_by: newStatus === 'completed' ? (isAdmin ? 'T&D' : (clientName || 'Cliente')) : null,
      completed_at: newStatus === 'completed' ? new Date().toISOString() : null,
    }).eq('id', task.id);
    r();
  };

  const changeStatus = async (id, status) => {
    await supabase.from('shared_tasks').update({ status }).eq('id', id);
    r();
  };

  const deleteTask = async (id) => {
    await supabase.from('shared_tasks').delete().eq('id', id);
    r();
  };

  const pending = tasks.filter(t => t.status !== 'completed');
  const completed = tasks.filter(t => t.status === 'completed');

  return (
    <div>
      <p style={{ fontSize:14, fontWeight:500, margin:'0 0 12px' }}>
        {isAdmin ? '📋 Pendientes compartidos' : '📋 Pendientes con T&D'}
      </p>
      {!isAdmin && <p style={{ fontSize:12, color:t.textSecondary, margin:'0 0 12px' }}>Tu equipo de T&D está trabajando en esto para ti</p>}

      {/* Active tasks */}
      {pending.length === 0 && <p style={{ fontSize:13, color:t.textSecondary, textAlign:'center', padding:12 }}>Sin pendientes. ¡Todo al día!</p>}
      {pending.map(task => (
        <div key={task.id} style={{ display:'flex', alignItems:'center', gap:4 }}>
          <div style={{ flex:1 }}>
            <TaskItem task={task} onToggle={toggleTask} onStatusChange={isAdmin ? changeStatus : null} canEdit={isAdmin} t={t} />
          </div>
          {isAdmin && <button onClick={() => deleteTask(task.id)} style={{ background:'none', border:'none', color:t.textSecondary, fontSize:14, cursor:'pointer', opacity:0.4, padding:'0 4px' }}>×</button>}
        </div>
      ))}

      {/* Completed */}
      {completed.length > 0 && (
        <details style={{ marginTop:12 }}>
          <summary style={{ fontSize:12, color:C.turquesa, cursor:'pointer', fontWeight:500, fontFamily:font }}>✅ Completados ({completed.length})</summary>
          <div style={{ marginTop:8 }}>
            {completed.map(task => <TaskItem key={task.id} task={task} onToggle={toggleTask} canEdit={false} t={t} />)}
          </div>
        </details>
      )}

      {/* Add task (admin only, or client can add too) */}
      {isAdmin && (
        <div style={{ marginTop:14, display:'flex', gap:6, flexWrap:'wrap' }}>
          <input value={title} onChange={e => setTitle(e.target.value)} onKeyDown={e => e.key === 'Enter' && addTask()} placeholder="Agregar pendiente..." style={{ ...inp, flex:1, minWidth:150 }} />
          <input type="date" value={dueDate} onChange={e => setDueDate(e.target.value)} style={{ ...inp, width:'auto' }} />
          <button onClick={addTask} style={{ background:C.logoGrad, color:'#fff', border:'none', borderRadius:50, padding:'8px 18px', fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:font }}>+ Agregar</button>
        </div>
      )}
    </div>
  );
}
